import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import { useSiteContext } from '@lib/context';
import { usePopupOpen } from '@lib/context';
import { useScrollFreeze } from '@hooks/useScrollFreeze';
import { DonateForm } from './donateForm';
import SimplePortableText from '@components/sanity/simplePortableText';

import Exit from '@svg/exit.svg';

const ModalInner = ({ title, copy, listId }) => {
  useScrollFreeze();
  const toggleDonateOpen = usePopupOpen();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className='bg-sand fixed top-0 left-0 w-full z-[200] flex flex-col items-center justify-center'>
      <div className='w-full hidden lg:flex lg:absolute top-0 justify-end py-gutter lg:py-8 px-gutter lg:px-10 pointer-events-none'>
        <button
          onClick={() => toggleDonateOpen(false)}
          className='rounded-full w-16 h-16 bg-teal bg-opacity-10 pointer-events-auto'>
          <Exit className='p-5 w-full h-full' />
        </button>
      </div>
      <div className='px-gutter flex flex-col lg:flex-row gap-x-32 gap-y-12 w-full items-center h-screen overflow-y-scroll pb-space-s lg:pb-0'>
        <div className='w-full lg:hidden top-0 flex justify-end py-10'>
          <button
            onClick={() => toggleDonateOpen(false)}
            className='rounded-full w-12 h-12 bg-teal bg-opacity-10'>
            <Exit className='p-3 w-full h-full' />
          </button>
        </div>
        <div className='w-full text-teal lg:mt-0'>
          <span className='blockH7 font-bold'>Support</span>
          <h2 className='blockH2'>{title}</h2>
          <div className='text-grey mt-4'>
            <SimplePortableText text={copy} />
          </div>
        </div>
        <div className='w-full md:py-space-s self-start min-h-screen flex items-center'>
          <DonateForm title={title} listId={listId} />
        </div>
      </div>
    </motion.div>
  );
};

export const DonateModal = () => {
  const { state } = useSiteContext();
  return (
    <AnimatePresence exitBeforeEnter>
      {state?.donateOpen && (
        <ModalInner
          title={state?.donateType}
          copy={state?.donateCopy}
          listId={state?.donateListId}
        />
      )}
    </AnimatePresence>
  );
};
